export default {
    CONNECT:       'estimate.connect',
    CONTACT_US:    'estimate.contact-us',
    GET_MIGRATION: 'estimate.get-migration',
    LIST:          'estimate.list',
    OPTIONS:       'estimate.options',
    REPORT:        'estimate.report',
    TARGET:        'estimate.target',
    VIEW:          'estimate.view',
    NAME:          'estimate.name',

    ENTITY: {
        CHANGE: 'estimate-entity.change',
        LIST:   'estimate-entity.list',
        VIEW:   'estimate-entity.view',
        PRICE:  'estimate-entity.price',
        TIME:   'estimate-entity.time',
    },

    INSTANCE: {
        CREATE:   'estimate-instance.create',
        LIST:     'estimate-instance.list',
        PROGRESS: 'estimate-instance.progress',
        STOP:     'estimate-instance.stop',
        VIEW:     'estimate-instance.view',
    },

    RATE: {
        VIEW:   'estimate-rate.view',
        CHANGE: 'estimate-rate.change',
    },
};
